import { useFeatureFlagClient } from '@/composables/featureFlags.js'
import { isSamePage } from '@/utils/middleware.js'
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (isSamePage(to, from)) {
    return
  }

  const featureFlagClient = useFeatureFlagClient(to)

  if (featureFlagClient?.isIdentified) {
    return
  }

  await featureFlagClient?.initialize()
})
